// extracted by mini-css-extract-plugin
export default {"root":"ProtectedHint__root--2TmYg","rootHovered":"ProtectedHint__rootHovered--Vv7n1"};